import { ActionNode, addEventListener, dispatchActionAttributes, readClickAttributes } from "./utilty";

export const button = (el: ActionNode) => {
  const onClick = () => {
    dispatchActionAttributes(el, readClickAttributes(el));
  };

  addEventListener(el, "click", onClick);
}
